<template>
  <div class="result">
    <div class="result-cointainer">
      <img :src="result" alt class="result_img" />
      <h3>当前阶段认证已通过</h3>
    </div>
  </div>
</template>
<script>
import result from "@/assets/result.png";

export default {
  data() {
    this.result = result;
    return {
      phone: "",
      user_info:{},
      type: 1,
      show: false,
      upload: false,
      img: "",
      registerCode: "",
      password: ""
    };
  },
  methods: {
    
  },
  created(){
  }
};
</script>
<style lang="less" scoped>
.result {
  width: 100%;
  height: 100%;
  background-color: #f3f2f1;
  &-cointainer {
    text-align: center;
    padding: 0 14px;
    .result_img {
      margin: 131px 0 25px;
      width: 94px;
      height: 94px;
    }
    > h3 {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #323333;
    }
    
    .result_info {
      margin-top: 10px;
      height: 40px;
      display: flex;
      padding: 0 12px;
      align-items: center;
      background-color: #f5f5f5;
      border-radius: 4px;
      > img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
      > span {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #575757;
      }
    }
  }
}
</style>
